<div class="form-group">
    <label *ngIf="label">{{label}}</label>
    <input type="text" class="form-control"  [placeholder]="placeholder" theme="dp-material" [disabled]="disabled" [(ngModel)]="value"
        [mode]="mode" [dpDayPicker]="dpDayPickerDateTimeConfig" (ngModelChange)="valueChange($event)">
    <ng-container *ngIf="formControl&& formControl.invalid">
        <small *ngIf="formControl.errors.required" class="form-text text-danger">
            Trường thông tin bắt buộc.
        </small>
    </ng-container>
</div>